import { render } from "./VisualEditor.vue?vue&type=template&id=3f5b3698"
import script from "./VisualEditor.vue?vue&type=script&lang=js"
export * from "./VisualEditor.vue?vue&type=script&lang=js"

import "./VisualEditor.vue?vue&type=style&index=0&id=3f5b3698&lang=scss"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__